<template>
	<div class="main">
		<div v-for="(item,index) in videoList" :key="index" class="item">
			<div class="video_con">
				<video class="video" :src="baseImgUrl + item.img" controls></video>
			</div>
			<div class="video_tit">{{item.titEn}}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Video",
	data() {
		return {
			baseImgUrl: process.env.VUE_APP_IMGURL,
			videoList: []
		}
	},
	mounted() {
		this.$api.get('about/getVideo').then(res => {
			this.videoList = res;
		});
	}
}
</script>

<style scoped>
.main{ font-family: 'SiYuan-Light', sans-serif; }
@media (max-width: 500px){
	.main{ width: 100%; padding: 30px 0 20px 0; display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.item{ width: 97%; height: 230px; margin: 0 1% 18px 0; animation: fadeInRight; animation-duration: 1.5s; }
	.video_con{ height: 200px; }
	.video{ width: 100%; height: 200px; object-fit: fill; }
	.video_tit{ height: 30px; line-height: 30px; font-size: 14px; text-align: center; background: #e0d3c4; }
}
@media (min-width: 500px) and (max-width: 726px){
	.main{ width: 100%; padding: 30px 0 20px 0; display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.item{ width: 48%; height: 160px; margin: 0 1% 18px 0; animation: fadeInRight; animation-duration: 1.5s; }
	.video_con{ height: 140px; }
	.video{ width: 100%; height: 140px; object-fit: fill; }
	.video_tit{ height: 20px; line-height: 20px; font-size: 14px; text-align: center; background: #e0d3c4; }
}
@media (min-width: 726px) and (max-width: 999px){
	.main{ width: 100%; padding: 30px 0 20px 0; display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.item{ width: 32%; height: 170px; margin: 0 1% 18px 0; animation: fadeInRight; animation-duration: 1.5s; }
	.video_con{ height: 150px; }
	.video{ width: 100%; height: 150px; object-fit: fill; }
	.video_tit{ height: 20px; line-height: 20px; font-size: 14px; text-align: center; background: #e0d3c4; }
}
@media (min-width: 999px) and (max-width: 1251px){
	.main{ width: 100%; padding: 30px 0 20px 0; display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.item{ width: 24%; height: 190px; margin: 0 1% 18px 0; animation: fadeInRight; animation-duration: 1.5s; }
	.video_con{ height: 170px; }
	.video{ width: 100%; height: 170px; object-fit: fill; }
	.video_tit{ height: 20px; line-height: 20px; font-size: 14px; text-align: center; background: #e0d3c4; }
}
@media (min-width: 1252px) and (max-width: 1845px){
	.main{ width: 100%; padding: 30px 0 20px 0; display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.item{ width: 24%; height: 250px; margin: 0 1% 18px 0; animation: fadeInRight; animation-duration: 1.5s; }
	.video_con{ height: 220px; }
	.video{ width: 100%; height: 220px; object-fit: fill; }
	.video_tit{ height: 30px; line-height: 30px; font-size: 16px; text-align: center; background: #e0d3c4; }
}
@media (min-width: 1846px) and (max-width: 2200px){
	.main{ width: 100%; padding: 30px 0 20px 0; display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.item{ width: 24%; height: 300px; margin: 0 1% 18px 0; animation: fadeInRight; animation-duration: 1.5s; }
	.video_con{ height: 270px; }
	.video{ width: 100%; height: 270px; object-fit: fill; }
	.video_tit{ height: 30px; line-height: 30px; font-size: 16px; text-align: center; background: #e0d3c4; }
}
@media (min-width: 2201px){
	.main{ width: 100%; padding: 30px 0 20px 0; display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.item{ width: 19%; height: 320px; margin: 0 1% 18px 0; animation: fadeInRight; animation-duration: 1.5s; }
	.video_con{ height: 290px; }
	.video{ width: 100%; height: 290px; object-fit: fill; }
	.video_tit{ height: 30px; line-height: 30px; font-size: 16px; text-align: center; background: #e0d3c4; }
}
</style>